import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";

import { getIsMobileWindow, setIsUnitTourScreen } from "slices";
import NotAvailable from "components/Icon/NotAvailable";
import { ButtonComp } from "components";
import { formatMessageEdit } from "utils/methods/index";
import { setShouldFetchSlots } from "slices/param-slice/index";
import { resetScheduleTourState } from "slices/schedule-tour-slice/index";

import { UnitTable, UnitView } from "../components";
import ListView from "../components/ListView";

const ShowUnits = ({ tableData, setFilterData, filterRef }) => {
  const isMobile = useSelector(getIsMobileWindow);

  const [selectedUnit, setSelectedUnit] = useState({});

  const dispatch = useDispatch();

  const tmlpEnabled = tableData?.[0]?.tmlp_enabled;
  const hidePricing = tableData?.[0]?.hide_pricing;

  useEffect(() => {
    setSelectedUnit(tableData[0] || {});
  }, [tableData]);

  const startScheduleTour = () => {
    // Clear cached tour data and force refetch
    dispatch(resetScheduleTourState());
    dispatch(setShouldFetchSlots(true));
    formatMessageEdit("ScheduleTour", "scheduleTour", "showUnits");
    dispatch(setIsUnitTourScreen(false));
  };

  let upperLength = (filterRef?.current?.offsetHeight || 0) + 250;

  return (
    <div
      className={`hayley-flex hayley-h-[calc(100dvh-${
        upperLength + "px"
      })] hayley-w-full hayley-justify-between xs:hayley-h-[calc(100dvh-280px)]  sm:hayley-h-[calc(100dvh-280px)] md:hayley-h-[calc(100dvh-270px)] lg:hayley-h-[calc(100dvh-240px)] `}
    >
      {tableData?.length ? (
        isMobile ? (
          <div className="hayley-max-h-[calc(100vh-345px)] hayley-w-full hayley-overflow-x-hidden hayley-overflow-y-scroll">
            <ListView tableData={tableData} startScheduleTour={startScheduleTour} />
          </div>
        ) : (
          <>
            <div style={{ maxHeight: "calc(100% - 50px)" }} className="hayley-max-h-full hayley-w-[60%]">
              <UnitTable data={tableData} setSelectedUnit={setSelectedUnit} selectedUnit={selectedUnit} tmlpEnabled={tmlpEnabled} hidePricing={hidePricing} />
            </div>
            <div className="hayley-max-h-full hayley-w-[40%] hayley-pl-4">
              <UnitView selectedUnit={selectedUnit || {}} startScheduleTour={startScheduleTour} />
            </div>
          </>
        )
      ) : (
        <div className="hayley-flex hayley-h-full hayley-w-full hayley-flex-col hayley-items-center hayley-justify-center hayley-border hayley-border-solid hayley-border-[#3333]">
          <NotAvailable />
          <p>No units available for the selected filters</p>
          <ButtonComp
            label={t("showAllUnit")}
            onClick={() => {
              setFilterData(null);
            }}
            disabled={false}
          />
        </div>
      )}
    </div>
  );
};

export default ShowUnits;
